import { WarningIcon } from '@p2p/assets/svg';
import { Button, Modal } from '@p2p/components';
import { TGetOrderResponse } from '@p2p/services';
import { useEffect, useState } from 'react';

import { useDeepLink } from '../useDeepLink';
import styles from './FailModal.module.scss';

export const FailModal = ({ order }: { order: TGetOrderResponse }) => {
  const [isActive, setIsActive] = useState(false);
  const { isFail, deepLinkTitle } = useDeepLink({ order });

  useEffect(() => {
    if (isFail) {
      setIsActive(true);
    }
  }, [isFail]);

  const handleClose = () => {
    setIsActive(false);
  };

  return (
    <Modal open={isActive} onClose={() => setIsActive(false)}>
      <section className={styles.modalContent}>
        <WarningIcon />
        <h2 className={styles.modalTitle}>Не удалось открыть приложение {deepLinkTitle}</h2>
        <p className={styles.description}>
          Если у вас возникли проблемы с быстрой оплатой, то вы можете оплатить переводом на
          реквизиты вручную.
        </p>
      </section>
      <Button onClick={handleClose} fullWidth>
        Хорошо
      </Button>
    </Modal>
  );
};
